import Vue from 'vue'
import Vuex from 'vuex'

import Auth from './modules/auth'
import User from './modules/user'
import Sys from './modules/sys'
import BaseData from './modules/base_data'
import Theme from './modules/theme'
import File from './modules/file'

import {
  getOtherSysStoreModules
} from '@/sys'

const modules = {
  Auth,
  User,
  BaseData,
  Theme,
  Sys,
  File,
  ...getOtherSysStoreModules()
}

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules,
  strict: debug
})
